import { useState } from 'react';

export const useReportVideoModalState = () => {
  const [reportModalOpen, setReportModalOpen] = useState(false);

  return {
    reportModalOpen,
    setReportModalOpen,
  };
};
